import React from 'react';

import Icon from 'components/DesignSystem/Icon';
import DSToast from 'components/DesignSystem/Toast';
import { cssVar } from 'constants/theme';
import './index.scss';

// Toast inferior simples (padrão do protótipo): fundo escuro + check.
// Auto-dismiss após 3 s (duração padrão do Toast do Design System).
export default function Toast({
  message,
  onClose,
}: {
  message: string;
  onClose: () => void;
}) {
  return (
    <DSToast
      message={message}
      onClose={onClose}
      className="videos-mobile-toast"
      icon={(
        <span className="videos-mobile-toast-check">
          <Icon iconType="checkmark" color={cssVar('text-on-accent')} size="small" />
        </span>
      )}
    />
  );
}
